import React, { useCallback, useMemo } from "react";
import FTLTableFooterStyles from "../styles/FTLTableFooterStyles.styles";
import { getVisiblePages, pageSizeOptions } from "../model/FTLTableFooterModel";
import { useMediaQuery, Box } from "@material-ui/core";
import clsx from "clsx";
import { useShortcut } from "ftl-core";
import { FTLTypography, FTLSelect } from "../../../..";
import { ArrowDownIcon } from "../../../icons";
import FTLPaginationButton from "./FTLPaginationButton";
export default ({ pageIndex, pageSize, pageCount, disabled, setPageSize, gotoPage = () => { }, className, }) => {
    const classes = FTLTableFooterStyles();
    const pages = Math.ceil(pageCount / pageSize);
    const getPages = useCallback((page) => {
        if (pages < page)
            return getVisiblePages(pages, pages);
        else
            return getVisiblePages(page, pages);
    }, [pageSize, pageCount]);
    const pageComponents = useMemo(() => {
        const visiblePages = getPages(pageIndex);
        return visiblePages.map((pageNumber) => {
            return (React.createElement(FTLPaginationButton, { isSelected: pageIndex + 1 === pageNumber, disabled: pageNumber > pages || disabled, onClick: () => {
                    if (pageIndex + 1 !== pageNumber) {
                        gotoPage(pageNumber);
                    }
                }, key: pageNumber }, pageNumber));
        });
    }, [getPages, pageIndex, gotoPage]);
    useShortcut("tableNextPage", () => {
        if (pageIndex + 1 < pages)
            gotoPage(pageIndex + 2);
    });
    useShortcut("tablePrevPage", () => {
        if (pageIndex > 0)
            gotoPage(pageIndex);
    });
    const mobile = useMediaQuery((theme) => theme.breakpoints.down("xs"));
    return (React.createElement("div", { className: clsx(classes.root, className) },
        React.createElement("div", { className: classes.container, style: pageCount ? {} : { display: "none" } },
            React.createElement(FTLTypography, { variant: "listItemText" }, `Всего: ${pageCount}`),
            React.createElement(Box, { marginLeft: 6, display: "flex", alignItems: "center" },
                React.createElement(FTLTypography, { variant: "listItemText" }, "\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435:"),
                React.createElement(FTLSelect, { searchable: false, disableClearable: true, size: "small", value: { label: String(pageSize), value: pageSize }, inputVariant: "standard", onChange: (option) => {
                        if (option.value !== pageSize) {
                            gotoPage(1);
                            setPageSize(option === null || option === void 0 ? void 0 : option.value);
                        }
                    }, options: pageSizeOptions, BoxProps: {
                        maxWidth: 60,
                    } }))),
        React.createElement("div", { className: classes.paginationContainer },
            React.createElement(FTLPaginationButton, { onClick: () => {
                    gotoPage(1);
                }, style: {
                    width: "86px",
                }, disabled: (pageIndex + 1 > 1 && pages ? false : true) || disabled }, "\u0412 \u043D\u0430\u0447\u0430\u043B\u043E"),
            React.createElement(FTLPaginationButton, { paginationType: "icon", disabled: (pageIndex >= 1 ? false : true) || disabled, onClick: () => {
                    gotoPage(pageIndex);
                } },
                React.createElement(ArrowDownIcon, { style: {
                        transform: "rotate(90deg)",
                        marginRight: 10,
                        marginLeft: 10,
                    } })),
            pageComponents,
            React.createElement(FTLPaginationButton, { paginationType: "icon", disabled: (pageIndex < pages - 1 ? false : true) || disabled, onClick: () => {
                    gotoPage(pageIndex + 2);
                } },
                React.createElement(ArrowDownIcon, { style: {
                        transform: "rotate(-90deg)",
                        marginRight: 10,
                        marginLeft: 10,
                    } })),
            React.createElement(FTLPaginationButton, { style: {
                    width: "86px",
                    marginRight: "0",
                }, onClick: () => {
                    gotoPage(pages);
                }, disabled: (pageIndex < pages - 1 && !mobile ? false : true) || disabled }, "\u0412 \u043A\u043E\u043D\u0435\u0446"))));
};
//# sourceMappingURL=FTLTableFooter.js.map